import styles from './SectionsEditor.module.scss'

interface VariantPickerProps {
  /** What the group is called, for assistive tech; the pills say the rest. */
  label: string
  value: string
  options: readonly string[]
  translate: (value: string) => string
  onChange: (value: string) => void
}

/**
 * One of the layouts a template offers for a section, as pills in a row.
 *
 * The names side by side with the chosen one filled, rather than a select
 * that shows one and keeps the other behind a click: there are never more
 * than a few, and a select with its floating label was twice this tall,
 * which made a card of nothing but its layout as tall as one with a photo.
 * The same pressed-button pattern as the template and layout pickers.
 */
function VariantPicker(props: VariantPickerProps) {
  const { label, value, options, translate, onChange } = props
  return (
    <div className={styles.variant} role="group" aria-label={label}>
      {options.map(option => {
        const selected = option === value
        return (
          <button
            key={option}
            type="button"
            className={`label-bold-medium ${styles.pill} ${
              selected ? styles.pillActive : ''
            }`}
            aria-pressed={selected}
            onClick={() => {
              if (!selected) onChange(option)
            }}
          >
            {translate(option)}
          </button>
        )
      })}
    </div>
  )
}

export default VariantPicker
